import { render, staticRenderFns } from "./DetailHasilUjianSKD.vue?vue&type=template&id=08f17042&scoped=true"
import script from "./DetailHasilUjianSKD.vue?vue&type=script&lang=js"
export * from "./DetailHasilUjianSKD.vue?vue&type=script&lang=js"
import style0 from "./DetailHasilUjianSKD.vue?vue&type=style&index=0&id=08f17042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f17042",
  null
  
)

export default component.exports